(function(){

	"use strict";

	/* In case you want to output a bunch of things to the debug console */
	var debug = false;
	var cartCookie;

  var shippingCalcExist = document.querySelector('.shipping-calc-wrapper');
	if(shippingCalcExist) return;

	/* The ID of the element that you want to add the shipping fields into */
  var productSection = document.querySelector('.shopping-calculator-action');
	if(!productSection){ log('Could not find the element'); return }

	/* the main product select element */
	var productSelect = document.querySelector('product-form-component input[name="id"]');
	if(!productSelect){ log('Could not find the main select element'); return }

	/* create a message box */
	var shippingMessage = document.createElement('p');
	shippingMessage.className = 'shipping-message';
	var shippingCountry = document.createElement('select');
	var shippingProvince = document.createElement('select');
	var shippingZip = document.createElement('input');

	/* We are just adding some dummy fields for example only. There's better ways to handle this */
	var initFields = function(){

		/* create the country picker */
		var countries = ['United States'];
		for (var i = 0; i < countries.length; i++) {
			shippingCountry.add(new Option(countries[i], countries[i], i===0));
		};
		shippingCountry.name = 'shipping_address[country]';

		shippingProvince.name = 'shipping_address[province]';

		/* create the zip / postcode field */
		shippingZip.type = 'text';
		shippingZip.name = 'shipping_address[zip]';
    shippingZip.value = '';
    shippingZip.placeholder = 'Enter your zip code';

		/* create a wrapper for the fields */
		var shippingCalcWrapper = document.createElement('div');
		shippingCalcWrapper.className = 'shipping-calc-wrapper';

		/* create a get rates button */
		var shippingCalcButton = document.createElement('button');
		shippingCalcButton.innerText = 'Calculate';
		shippingCalcButton.className = 'button shippingCalcButton';
		shippingCalcButton.onclick=function(){
			if(!productSelect.value.length){ return false }
			if(shippingZip.value != ''){
				shippingCalcButton.innerText = 'Calculating...';
				shippingCalcButton.className += ' disabled';
			}
			cartCookie = getCookie('cart');
			var tempCookieValue = tempCookieValue || "temp-cart-cookie___" + Date.now();
			var fakeCookieValue = fakeCookieValue || "fake-cart-cookie___" + Date.now();

			/* if not found, make a new temp cookie */
			if(!cartCookie){ 
				log('no cookie found');
				updateCartCookie(tempCookieValue);
				cartCookie = getCookie('cart');
			}else{
				log('cookie found');
			}

			/* if found but has a weird length, bail */
			if(cartCookie.length < 32){ log('cart ID not valid');return }

			/* Change the cookie value to a new 32 character value */
			updateCartCookie(fakeCookieValue);
			log(getCookie('cart'));

			getRates(parseInt(productSelect.value));
			return false;
		};

		/* create some labels for the fields */
		var labelNames = ['CEP'];
		var labels = [];
		for (var i = 0; i < labelNames.length; i++) {
			var label = document.createElement('label');
			label.innerText = labelNames[i];
			labels.push(label);
		};

		shippingCalcWrapper.appendChild(shippingZip);
		shippingCalcWrapper.appendChild(shippingCalcButton);
		shippingCalcWrapper.appendChild(shippingMessage);

		/* add to the page */
		productSection.appendChild(shippingCalcWrapper);

		var storedZip = localStorage.getItem('zip_code');
		var storedZone = localStorage.getItem('growing_zone');
		
		if (storedZip && /^\d{5}$/.test(storedZip)) {
		  shippingZip.value = storedZip;
		  
		  if (storedZone) {
				updateGrowingZoneDisplay(storedZone, storedZip);
		  }
		  
		  var cachedRates = localStorage.getItem('shipping_rates_' + storedZip);
		  if (cachedRates) {
				try {
					var result = JSON.parse(cachedRates);
					renderShippingRates(result, storedZip);
				} catch (e) {
					setTimeout(function() {
						shippingCalcButton.click();
					}, 100);
				}
		  } else {
				setTimeout(function() {
					shippingCalcButton.click();
				}, 100);
		  }
		}

	};

	/* A console logging function */
	function log (a){
		if(!debug){ return }
		console.log(a);
	};

	/* get cookie by name */
	var getCookie = function(name) {
		var value = "; " + document.cookie;
		var parts = value.split('; '+name+'=');
		if (parts.length == 2) return parts.pop().split(";").shift();
	};

	/* update the cart cookie value */
	var updateCartCookie = function(a) {
		log('changing cart cookie value to: '+a);
		var date = new Date();
		date.setTime(date.getTime()+(14*86400000));
		var expires = '; expires='+date.toGMTString();
		document.cookie = 'cart='+a+expires+'; path=/';
	};

	/* reset the cart cookie value */
	var resetCartCookie = function(){
		updateCartCookie(cartCookie);
		log(getCookie('cart'));
	};

	var getRates = function(variantId){
		if(typeof variantId === 'undefined'){ return }

		fetch(`https://phzmapi.org/${shippingZip.value}.json`)
			.then(function(res) { return res.json(); })
			.then(function(data) {
				var userState = data.state || 'California';
				
				if (data.zone) {
					localStorage.setItem('growing_zone', data.zone);
					updateGrowingZoneDisplay(data.zone, shippingZip.value);
				}
				if (data.state) {
					localStorage.setItem('user_state', data.state);
				}

				var productQuantity = document.querySelector('.quantity__input');
				var quantity = productQuantity ? parseInt(productQuantity.value):1;
				var addData = {
					'id':variantId,
					'quantity':quantity
				};

				fetch('/cart/add.js', {
					body: JSON.stringify(addData),
					credentials: 'same-origin',
					headers: {
						'Content-Type': 'application/json',
						'X-Requested-With':'xmlhttprequest'
					},
					method: 'POST'
				}).then(function(response) {
					return response.json();
				}).then(function(json) {
					fetch('/cart/shipping_rates.json?' + new URLSearchParams({
						'shipping_address[country]':shippingCountry.value,
						'shipping_address[province]':userState,
						'shipping_address[zip]':shippingZip.value
					})).then(function(response) {
						return response.json();
					}).then(function(result) {
						try {
							localStorage.setItem('shipping_rates_' + shippingZip.value, JSON.stringify(result));
						} catch (e) {}
						renderShippingRates(result, shippingZip.value);
						resetCartCookie()
					}).catch(function(err) {
						console.error(err);
						resetCartCookie();
						shippingMessage.innerHTML = '';
						document.querySelector('.shippingCalcButton').innerText = 'Calculate';
						document.querySelector('.shippingCalcButton').className = 'button shippingCalcButton';
					})
				}).catch(function(err) {
					console.error(err);
					resetCartCookie()
				});
			})
			.catch(function(err) {
				console.error(err);
				resetCartCookie();
			});
	};

	var updateGrowingZoneDisplay = function(zone, zipCode) {
		var summaryZone = document.querySelector('.geolocation-growing-zone__summary-zone');
		if (summaryZone) {
			summaryZone.textContent = zone ? ': ' + zone : '';
		}
		
		var zipInput = document.querySelector('.geolocation-zip-code');
		if (zipInput && zipCode) {
			zipInput.value = zipCode;
		}
		
		var resultValue = document.querySelector('.geolocation-growing-zone__result-text-value');
		if (resultValue) {
			resultValue.textContent = zone || '';
		}
	};

	function renderShippingRates(result, zip) {
		if (zip && /^\d{5}$/.test(zip)) {
			localStorage.setItem('zip_code', zip);
		}

		var calculatorContainer = document.querySelector('.shopping-calculator');
		if(result.shipping_rates && result.shipping_rates.length){
			if (calculatorContainer) calculatorContainer.classList.remove('shipping-error');
			let messageHtml = '<ul>'
			for (let i = 0; i < result.shipping_rates.length; i++) {
			const element = result.shipping_rates[i];
			var deliveryDays = '';
			if (element.delivery_days.length > 0) {
				var minDays = element.delivery_days[0];
				var maxDays = element.delivery_days[1];
				
				if (maxDays && maxDays !== minDays) {
					// Show range when min and max are different
					deliveryDays = `<span>${minDays}-${maxDays} days</span>`;
				} else if (minDays == 1) {
					deliveryDays = '<span>1 day</span>';
				} else {
					deliveryDays = `<span>${minDays} days</span>`;
				}
			}
				if (element.name.includes('Free Shipping')) {
					messageHtml += `
					<li> 
						${element.name}
						<br>
						${deliveryDays?deliveryDays:''}
					</li>
					`;
				} else {
					messageHtml += `
					<li> 
						${element.name} for <b>$${element.price}</b>
						<br>
						${deliveryDays?deliveryDays:''}
					</li>
					`;
				}
				if (i === result.shipping_rates.length) {
					messageHtml += '</ul>'
				}
			}
			shippingMessage.innerHTML = messageHtml;
			document.querySelector('.shippingCalcButton').innerText = 'Calculate';
			document.querySelector('.shippingCalcButton').className = 'button shippingCalcButton';

		const titleSummary = document.querySelector('.shipping-title-summary');
		if (titleSummary) titleSummary.style.display = 'block';
		if (titleSummary && result.shipping_rates.length > 0) {
			var first = result.shipping_rates[0];
			var days = '';
			if (first.delivery_days && first.delivery_days.length > 0) {
				var minDays = first.delivery_days[0];
				var maxDays = first.delivery_days[1];
				
				if (maxDays && maxDays !== minDays) {
					days = `${minDays}-${maxDays} days`;
				} else if (minDays == 1) {
					days = '1 day';
				} else {
					days = `${minDays} days`;
				}
			}
			titleSummary.innerHTML = `Estimated delivery to <b>${zip}</b>: <b>${days}</b>`;
		}

		} else {
			if (calculatorContainer) calculatorContainer.classList.add('shipping-error');
			shippingMessage.innerHTML = 'We\'re sorry, but we do not currently deliver to your address. Please call us if you would like to arrange a special delivery';
			document.querySelector('.shippingCalcButton').innerText = 'Calculate';
			document.querySelector('.shippingCalcButton').className = 'button shippingCalcButton';
			const titleSummary = document.querySelector('.shipping-title-summary');
			if (titleSummary) titleSummary.textContent = 'Your zip code is outside of our normal delivery area';
		}
	}

	initFields();
})()